import React from "react";
import { Script } from "gatsby";

const WistiaScripts = ({ wistiaVideoId }) => {
  const wistiaApiSrc = "https://fast.wistia.com/assets/external/E-v1.js";
  const wistiaVideoSrc = `https://fast.wistia.com/embed/medias/${wistiaVideoId}.jsonp`;

  return (
    <>
      <Script src={wistiaApiSrc} async strategy="idle" />
      <Script src={wistiaVideoSrc} async strategy="idle" />
    </>
  );
};

export default WistiaScripts;
